/* eslint-disable functional/no-conditional-statement */
import { useEffect } from "react";
import { useSettingsValueData } from "../../app/hooks/useSettingsValueData";

export function useToastPositionEffect(showBreadCrumbs: boolean) {
  const settings = useSettingsValueData();
  const isHeaderFixed = settings.data.styleOptions?.headerFixed;

  useEffect(() => {
    const toastElement =
      document.querySelector<HTMLElement>(".mkhc-toast-fixed");
    const headerElement =
      document.querySelector<HTMLElement>("#mkhc-page-header");
    const headerHeight = headerElement?.offsetHeight ?? 0;

    if (isHeaderFixed) {
      toastElement?.style.setProperty("top", `${headerHeight}px`);
    }
  }, [showBreadCrumbs]);
}
